import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Calendar, ArrowRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_valuebot/artifacts/etd4vs0l_Absolin_logo_Blue-HD.png";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="app-footer">
      {/* Schedule Demo CTA */}
      <div className="border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <h3 className="text-base font-semibold mb-1">Ready to transform your business?</h3>
              <p className="text-slate-400 text-xs">Get a personalized demo and see ABSOLIN in action.</p>
            </div>
            <Link to="/schedule-demo"
              className="inline-flex items-center gap-2 bg-[#0066CC] hover:bg-[#0055aa] text-white px-6 py-2.5 rounded-lg text-sm font-semibold transition-colors"
              data-testid="footer-schedule-demo-btn">
              <Calendar className="w-4 h-4" />
              Schedule Your Demo
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand + Social */}
          <div className="space-y-3">
            <img src={LOGO_URL} alt="ABSOLIN" className="h-8 w-auto object-contain brightness-0 invert" />
            <p className="text-slate-400 text-xs leading-relaxed max-w-xs">
              Infinite Digital Possibilities. ERP solutions &amp; custom software across 21+ industries.
            </p>
            <div className="flex gap-3">
              <a href="https://linkedin.com/company/absolin" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-[#0066CC] transition-colors">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="https://twitter.com/absolinsoft" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-[#0066CC] transition-colors">
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-slate-300 text-xs uppercase tracking-wider mb-3">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/verticals" className="footer-link text-xs">Industry Solutions</Link></li>
                <li><Link to="/resources" className="footer-link text-xs">Resources</Link></li>
                <li><Link to="/case-studies" className="footer-link text-xs">Case Studies</Link></li>
                <li><Link to="/testimonials" className="footer-link text-xs">Testimonials</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-slate-300 text-xs uppercase tracking-wider mb-3">Company</h4>
              <ul className="space-y-2">
                <li><a href="https://www.absolinsoft.com/about-us/" target="_blank" rel="noopener noreferrer" className="footer-link text-xs">About Us</a></li>
                <li><a href="https://www.absolinsoft.com/services/" target="_blank" rel="noopener noreferrer" className="footer-link text-xs">Services</a></li>
                <li><a href="https://www.absolinsoft.com/blog/" target="_blank" rel="noopener noreferrer" className="footer-link text-xs">Blog</a></li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-slate-300 text-xs uppercase tracking-wider mb-3">Contact Us</h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <MapPin className="h-3.5 w-3.5 text-[#0066CC] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-xs">Visakhapatnam &bull; Hyderabad</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-3.5 w-3.5 text-[#0066CC] flex-shrink-0" />
                <a href="tel:+918297555678" className="footer-link text-xs">+91 829 755 5678</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-3.5 w-3.5 text-[#0066CC] flex-shrink-0" />
                <a href="mailto:info@absolinsoft.com" className="footer-link text-xs">info@absolinsoft.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-5">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-slate-500 text-xs" data-testid="footer-copyright">
              &copy; 2014-{new Date().getFullYear()} ABSOLIN. All rights reserved.
            </p>
            <div className="flex gap-4">
              <a href="https://www.absolinsoft.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="footer-link text-xs">Privacy Policy</a>
              <a href="https://www.absolinsoft.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="footer-link text-xs">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
